import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/border.css'
import './assets/styles/reset.css'
import  SvgIcon from '@/icons' // svg图标组件
import '@/router/permission.js'
import httpService from '@/util/axios'
/* 1. 引入你想用的所有图标 */
import { Plus } from '@element-plus/icons-vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

document.title = "慧生活布艺软装";
const app = createApp(App);
app.use(store).use(router).use(ElementPlus).use(SvgIcon).mount('#app')
app.component('QuillEditor', QuillEditor)
const LOCAL_VERSION = process.env.VUE_APP_VERSION  // 打包时注入的 package.json 版本
/* 2. 全局注册 */
app.component('Plus', Plus)   // 关键：把 Plus 注册成全局组件

// fetch('/version.json', { cache: 'no-store' })      // 每次都不走缓存
//   .then(r => r.json())                             // 返回 "0.1.2"
//   .then(remote => {
//     if (remote !== LOCAL_VERSION) {
//       // 服务器版本更新 → 强制刷新
//       location.replace(location.href)
//     }
//   })
//   .catch(() => {
//     /* 拉不到就放弃，不做任何处理 */
//   })


//监听路由变化，如果路径为空，则条状/login
// router.beforeEach((to, from, next) => {
//   if (to.path === '/') {
//     next('/login');
//   } else {
//     next();
//   }
// });



// import { createApp } from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
// import './assets/styles/border.css'
// import './assets/styles/reset.css'
// import SvgIcon from '@/icons'          // svg 图标插件
// import '@/router/permission.js'

// /* 1. 引入图标 */
// import { Plus } from '@element-plus/icons-vue'

// document.title = '慧生活布艺软装'

// /* 2. 只创建一次实例，链式写完 */
// const app = createApp(App)

// app.use(store)
//    .use(router)
//    .use(ElementPlus)
//    .use(SvgIcon)
//    .component('Plus', Plus)   // 全局注册 Plus 图标
//    .mount('#app')